// extracted by mini-css-extract-plugin
module.exports = {"blockQuote":"BlockQuote-module--block-quote--3n8di","blockQuote__author":"BlockQuote-module--block-quote__author--2Y6zO"};